import { actions$ } from "mini-rx-store";
import { catchError, map, of, switchMap } from "rxjs";
import { ofType } from "ts-action-operators";

import {
  loadGremienKennzahlen,
  loadGremiumBesetzung,
  loadGremiumDrucksachen,
  loadGremiumSitzungen,
} from "./gremien-actions.js";
import { gremienService } from "../service/gremien-service.js";
import { isoTag } from "../../../common/format/de-format.js";

export const loadGremienKennzahlenEffect = actions$.pipe(
  ofType(loadGremienKennzahlen.action),
  switchMap(() =>
    gremienService.ladeKennzahlen().pipe(
      map((k) => loadGremienKennzahlen.success(k)),
      catchError((err) => of(loadGremienKennzahlen.fail(err))),
    ),
  ),
);

/**
 * Sitzungen — die Grenze zwischen kommend und vergangen ist der heutige TAG.
 * Sie wird hier gebildet, nicht im Dienst: Ein Dienst, der die Uhr liest, ist
 * nicht prüfbar.
 */
export const loadGremiumSitzungenEffect = actions$.pipe(
  ofType(loadGremiumSitzungen.action),
  switchMap(({ payload: gremiumId }) =>
    gremienService.ladeSitzungen(gremiumId, isoTag(new Date())).pipe(
      map((s) => loadGremiumSitzungen.success(s)),
      catchError((err) => of(loadGremiumSitzungen.fail(err))),
    ),
  ),
);

export const loadGremiumDrucksachenEffect = actions$.pipe(
  ofType(loadGremiumDrucksachen.action),
  switchMap(({ payload: gremiumId }) =>
    gremienService.ladeDrucksachen(gremiumId).pipe(
      map((d) => loadGremiumDrucksachen.success(d)),
      catchError((err) => of(loadGremiumDrucksachen.fail(err))),
    ),
  ),
);

export const loadGremiumBesetzungEffect = actions$.pipe(
  ofType(loadGremiumBesetzung.action),
  switchMap(({ payload: gremiumId }) =>
    gremienService.ladeBesetzung(gremiumId).pipe(
      map((b) => loadGremiumBesetzung.success(b)),
      catchError((err) => of(loadGremiumBesetzung.fail(err))),
    ),
  ),
);

export const gremienEffects = [
  loadGremienKennzahlenEffect,
  loadGremiumSitzungenEffect,
  loadGremiumDrucksachenEffect,
  loadGremiumBesetzungEffect,
];
